import { Phone, ShoppingBag, CalendarCheck } from 'lucide-react';
import { RESTAURANT } from '../constants/restaurant';

export const MobileBottomBar = () => {
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-brand-cream/95 backdrop-blur-xl border-t border-brand-ivory shadow-[0_-10px_30px_rgba(43,27,23,0.10)] pb-safe"
    >
      <div className="grid grid-cols-3 gap-2 px-3 pt-3">
        <a
          href={`tel:${RESTAURANT.phoneRaw}`}
          data-testid="mobile-bar-call"
          className="flex flex-col items-center justify-center gap-1 py-2 rounded-xl text-brand-coffee active:scale-95 transition"
        >
          <span className="w-9 h-9 rounded-full bg-brand-coffee text-brand-cream flex items-center justify-center">
            <Phone className="w-4 h-4" />
          </span>
          <span className="text-[10px] uppercase tracking-[0.18em] font-bold">Call</span>
        </a>
        <a
          href={RESTAURANT.orderUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-order"
          className="flex flex-col items-center justify-center gap-1 py-2 rounded-xl text-brand-cream bg-brand-burgundy active:scale-95 transition shadow-[0_8px_20px_rgba(139,26,26,0.30)]"
        >
          <span className="w-9 h-9 rounded-full bg-brand-cream/15 flex items-center justify-center">
            <ShoppingBag className="w-4 h-4" />
          </span>
          <span className="text-[10px] uppercase tracking-[0.18em] font-bold">Order</span>
        </a>
        <a
          href={RESTAURANT.bookUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-book"
          className="flex flex-col items-center justify-center gap-1 py-2 rounded-xl text-brand-coffee active:scale-95 transition"
        >
          <span className="w-9 h-9 rounded-full bg-brand-gold text-brand-coffee flex items-center justify-center">
            <CalendarCheck className="w-4 h-4" />
          </span>
          <span className="text-[10px] uppercase tracking-[0.18em] font-bold">Book</span>
        </a>
      </div>
    </div>
  );
};

export default MobileBottomBar;
